"use client";
import { getWebUrl } from "@areahub/config";
import { Box, chakra, Heading } from "@chakra-ui/react";
import Case from "case";
import * as React from "react";
import { PropsWithChildren } from "react";
import { Link } from "../../../components/link";
export interface StatSectionWrapperProps extends PropsWithChildren {
  title: string;
  subtitle: string;
  knowledgeCenterSlug?: string;
  colorScheme?: string;
}
export const StatsSectionWrapper: React.FC<StatSectionWrapperProps> = ({
  children,
  title,
  subtitle,
  knowledgeCenterSlug,
  colorScheme,
}) => {
  return (
    <Box as="section" pb="20">
      <Box bg={`${colorScheme || "blue"}.600`} pt="20" pb="70px">
        <Box
          maxW={{ base: "xl", md: "7xl" }}
          mx="auto"
          px={{ base: "6", md: "8" }}
        >
          <Box mb="30px" color="white" maxW="2xl">
            <Heading
              size="xl"
              letterSpacing="tight"
              fontWeight="bold"
              lineHeight="normal"
              id={Case.lower(title).replace(/\s/g, "-")}
            >
              {title}
            </Heading>
            <chakra.span fontSize="lg" mt="4" fontWeight="medium">
              {subtitle}{" "}
              {knowledgeCenterSlug && (
                <Link
                  href={`${getWebUrl()}/individuals/knowledge-center/category/${knowledgeCenterSlug}`}
                >
                  Learn&nbsp;More&nbsp;→
                </Link>
              )}
            </chakra.span>
          </Box>
        </Box>
      </Box>
      <Box mt="-20">
        <Box
          maxW={{ base: "xl", md: "7xl" }}
          mx="auto"
          px={{ base: "6", md: "8" }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};
